import type { ReactNode } from 'react'
import styles from './OCRScopeJobDetailBody.module.css'

export interface OCRScopeJobDetailBodyProps {
  children?: ReactNode
}

export function OCRScopeJobDetailBody({
  children,
}: OCRScopeJobDetailBodyProps) {
  return <div className={styles.root}>{children}</div>
}

export interface OCRScopeJobDetailBodyMainProps {
  basicInformation: ReactNode
  legendInformation: ReactNode
}

export function OCRScopeJobDetailBodyMain({
  basicInformation,
  legendInformation,
}: OCRScopeJobDetailBodyMainProps) {
  return (
    <div className={styles.detailBodyMain}>
      <div className={styles.leftCol}>{basicInformation}</div>
      <div className={styles.rightCol}>{legendInformation}</div>
    </div>
  )
}
